// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__1hhNR","colMaxWidth":"Table_colMaxWidth__28NV9"};